import React, { useContext, useEffect } from "react";
import { ImageType } from "../../images/svg";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getEklokDataSelector,
  getSoundBlockLevelSelector,
} from "../../store/data/common-data.store";
import PullToRefresh from "react-simple-pull-to-refresh";
import { Box, makeStyles } from "@material-ui/core";
import {
  getBlocksSoundsData,
  getBlocksSoundsDataSuccess,
  setBlocksSoundsLevel,
} from "../../store/blocks-sounds-page.store";
import BlocksSoundsView from "../../views/mobile-frame/blocks-sounds/BlocksSoundsView";

const useStyles = makeStyles((theme) => ({
  container: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const BlocksSoundsContainer = ({ eklok }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const { token } = useContext(AuthContext);

  const { dataFetched, error, loading } = useSelector((state) => {
    return state.blocksSounds;
  });
  const eklokData = useSelector(getEklokDataSelector);
  const soundBlockLevel = useSelector(getSoundBlockLevelSelector);

  const soundBlockLevelChoices = {
    0: {
      label: t("mobile_frame.home.allow_all"),
      image: ImageType.SoundsAllowAll,
      onClick: () => {
        dispatch(
          setBlocksSoundsLevel({
            token: token,
            eklok: eklok,
            soundBlockLevel: "0",
          }),
        );
      },
    },
    1: {
      label: t("mobile_frame.home.only_sounds_and_hours"),
      image: ImageType.OnlySoundsAndHours,
      onClick: () => {
        dispatch(
          setBlocksSoundsLevel({
            token: token,
            eklok: eklok,
            soundBlockLevel: "1",
          }),
        );
      },
    },
    2: {
      label: t("mobile_frame.home.deny_all"),
      image: ImageType.SoundsDenyAll,
      onClick: () => {
        dispatch(
          setBlocksSoundsLevel({
            token: token,
            eklok: eklok,
            soundBlockLevel: "2",
          }),
        );
      },
    },
  };

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(
        getBlocksSoundsData({
          token: token,
          eklok: eklok,
        }),
      );
      resolve();
    });

  useEffect(() => {
    if (!eklokData || eklokData.id !== eklok) {
      dispatch(
        getBlocksSoundsData({
          token: token,
          eklok: eklok,
        }),
      );
    } else {
      dispatch(getBlocksSoundsDataSuccess());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading ? <Loading /> : null}
      <Box className={classes.container}>
        {error ? <Error message={{ message: error.message }} /> : null}
        {dataFetched ? (
          <BlocksSoundsView
            soundBlockLevel={soundBlockLevel}
            soundBlockLevelChoices={soundBlockLevelChoices}
          />
        ) : null}
      </Box>
    </PullToRefresh>
  );
};

export default BlocksSoundsContainer;
